import React from 'react'
import './About_Me_Cards.css'
import my_img from '../jpegs/images.jpg'

const About_Me_Cards = () => {
  return (
    <div className='about-me-card'>
      <img src={my_img} alt="my-pic"></img>
    </div>
  )
}

export default About_Me_Cards
